import { Paper, Switch, Typography, useTheme } from "@mui/material";
import { Box } from "@mui/system";
import useStyles from "./styles";
import { PublicOutlined } from "@mui/icons-material";

// Card selecionável (toggle) de uma opção de CDN ou tipo de tráfego.
// "item" aceita um ícone de imagem (logo de CDN) ou um componente de ícone MUI,
// sempre exibido sobre um fundo colorido (item.color) para manter contraste.
export default function ConfigVisibilidadeTile({ item, checked, onToggle }) {
  const theme = useTheme();
  const styles = useStyles(theme);

  const handleToggle = () => onToggle(item.key);

  return (
    <Paper
      variant="outlined"
      onClick={handleToggle}
      sx={{
        ...styles.tile,
        ...(checked ? styles.tileActive : {}),
      }}
    >
      <Box sx={{ ...styles.iconWrapper, backgroundColor: item.color }}>
        {item.image ? (
          <Box
            component="img"
            src={item.image}
            alt={item.label}
            sx={styles.iconImage}
          />
        ) : item.Icon ? (
          <item.Icon sx={styles.icon} />
        ) : (
          <PublicOutlined sx={styles.icon} />
        )}
      </Box>

      <Box sx={styles.info}>
        <Typography sx={styles.label}>{item.label}</Typography>
        {item.description && (
          <Typography sx={styles.description}>{item.description}</Typography>
        )}
      </Box>

      <Switch
        size="small"
        checked={checked}
        onClick={(e) => e.stopPropagation()}
        onChange={handleToggle}
      />
    </Paper>
  );
}
